export default __webpack_public_path__ + "static/media/News & Announcements.7ce0b3dd.svg";